<div class="spinnerWrapper">
  <img src="./assets/images/Form-submission-web.gif" alt="SeeMyLegacy" *ngIf="showFormImage"
    class="tw-h-[375px] tablet:tw-w-auto tw-max-w-[650px] tw-w-[650px] tw-hidden tablet:tw-flex" />
  <img src="./assets/images/Form-submission-mobile.gif" alt="SeeMyLegacy" *ngIf="showFormImage"
    class="tw-h-[375px] tablet:tw-w-auto tw-max-w-[650px] tw-w-[650px] tablet:tw-hidden tw-flex" />
</div>